import type { FaireProductEntity } from "../../entity_types/product";

export const p_9irxs0gg: FaireProductEntity = {
  token: "p_9irxs0gg",
  type: "product",
  name: "I'd Fuck Me Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/res/hszgttpjt/image/upload/8cdbfb724c34d3f150681a205515a22a7837bca1f5fe128c0c08cf295829e85e/1544664892.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/cb8e197eeb805a40a314ae4a0ff1ce4ef9b156c2e0b126e509272236ca9f0c2b/1555102110.jpg",
    "https://cdn.faire.com/fastly/2c58a94e6987f4f7f6f1a6f192caf5d4b8ac7552f37253bf0c2ae31021cc08d5.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/f5b22b0c52aa4d029816a8d58a0eb1ee955f4d078f8137a56ad414888e95eba1/1555102120.jpg"
  ],
  priceDollars: 6.75,
  description: "Limited Availability - Will Not Restock\n\nI’d fuck me so hard… PUT THE SOCKS IN THE BASKET!!!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:15.195Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
